import type { AxiosError } from 'axios'
import { ElMessage } from 'element-plus'

import i18n from '@/lang'

import type { ErrorHandlerPort, ErrorHandlerResult } from '../ports/ErrorHandlerPort'

const { t } = i18n.global

type ErrorResponseData = {
  message?: string
  errorMsg?: string
}

function getErrorMessage(data: unknown): string | undefined {
  if (typeof data !== 'object' || data === null) return undefined

  const { message, errorMsg } = data as ErrorResponseData

  return message || errorMsg
}

/**
 * General fallback error handler for all unhandled errors
 * This should have the lowest priority and handle any error that other handlers don't process
 */
export class GeneralErrorHandler implements ErrorHandlerPort {
  canHandle(): boolean {
    return true
  }

  async handleError(error: AxiosError): Promise<ErrorHandlerResult> {
    let message: string

    if (!error.response) {
      message = t('errorMessages.unknownError')
    } else {
      message = getErrorMessage(error.response.data) || t('errorMessages.unknownError')
    }

    return {
      handled: true,
      shouldShowToast: true,
      message,
      shouldReject: true,
      customAction: () => {
        ElMessage({
          message: `${t('notification.error')}: ${message}`,
          type: 'error',
          grouping: true,
          duration: 5000
        })
      }
    }
  }
}
